import { render } from "./OnboardingResult.vue?vue&type=template&id=54023da0&scoped=true&ts=true"
import script from "./OnboardingResult.vue?vue&type=script&lang=ts"
export * from "./OnboardingResult.vue?vue&type=script&lang=ts"

import "./OnboardingResult.vue?vue&type=style&index=0&id=54023da0&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54023da0"]])

export default __exports__